import { render, staticRenderFns } from "./ClaimProducts.vue?vue&type=template&id=886bafde&scoped=true&"
import script from "./ClaimProducts.vue?vue&type=script&lang=ts&"
export * from "./ClaimProducts.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimProducts.vue?vue&type=style&index=0&id=886bafde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886bafde",
  null
  
)

export default component.exports